export default {
  // disabled - under-translated (< 80%)
  en: 'English',
  cy: 'Cymraeg',
};
